document.addEventListener("DOMContentLoaded",function () {
  
  $(document).ready(function () {
    $('#feTracking-btn').on('click', function () {
      $('#feTracking-content').html('');
      const awb_number = $('#fe_awb_number').val();
      feLoadTracking(awb_number);
    });
    
    
    const feLoadTracking = function (awb_number) {
      
      $.ajax({
        url: '/fe/tracking_message',
        type: 'POST',
        data: {
          awb_number: awb_number
        },
        success: function (response) {
          $('#feTracking-content').html(response);
        },
        error: function () {
          $('#feTracking-content').html('<p>Errore nel caricamento del tracking</p>');
        }
      });
    }
    
  });
});
